import React from 'react';
export const Logo = () => {
  return <div className="flex items-center gap-2" data-id="element-29">
      <div className="w-10 h-10 flex items-center justify-center overflow-hidden rounded-full shadow-lg" data-id="element-30">
        <img src="https://mirrorful-production.s3.us-west-1.amazonaws.com/patterns/assets/jwsrwc4ulmzfbdzuy8nr4q/3421766c-d8ad-4aaf-b6ec-936b0d30906e/image.png" alt="TailorPro Logo" className="w-full h-full object-cover" data-id="element-31" />
      </div>
      <span className="text-xl font-semibold text-gray-800" data-id="element-32">TailorPro</span>
    </div>;
};